import { render, staticRenderFns } from "./v4-news.vue?vue&type=template&id=245f9415&"
import script from "./v4-news.vue?vue&type=script&lang=js&"
export * from "./v4-news.vue?vue&type=script&lang=js&"
import style0 from "./v4-news.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245f9415')) {
      api.createRecord('245f9415', component.options)
    } else {
      api.reload('245f9415', component.options)
    }
    module.hot.accept("./v4-news.vue?vue&type=template&id=245f9415&", function () {
      api.rerender('245f9415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v4-news/v4-news.vue"
export default component.exports